import {
  TOwnUserRole,
  TUseOwnUserRoles,
} from '@/shared/features/rbac/hooks/use-own-user-roles/use-own-user-roles.types';
import { useReadOwnUserRolesQuery } from '@/shared/redux/api/ident/ident-api';

// Console/Backoffice expose own roles under different keys; normalize here.
type TOwnRolesData = {
  readUserRolesForOwnUser?: { items: TOwnUserRole[] };
  readSuperUserRolesForOwnUser?: { items: TOwnUserRole[] };
};

export const useOwnUserRoles = (): TUseOwnUserRoles => {
  const { data, isLoading } = useReadOwnUserRolesQuery({});

  const normalized = data as TOwnRolesData | undefined;
  const roles =
    normalized?.readUserRolesForOwnUser?.items ??
    normalized?.readSuperUserRolesForOwnUser?.items ??
    [];

  const roleIds = new Set(roles.map((role) => role.userRoleId));

  return {
    roles,
    roleIds,
    itemCount: roles.length,
    isLoggedInUserRole: (userRoleId?: string) =>
      Boolean(userRoleId && roleIds.has(userRoleId)),
    isLoading,
  };
};
